import React from 'react';
import styled from 'styled-components';

const CanvasContainer = styled.div`
  position: absolute;
  top: ${props => props.top || '60px'};
  left: 0;
  width: 100%;
  height: ${props => props.height || 'calc(100% - 60px)'};
  overflow: hidden;
  pointer-events: none;
  border-radius: 20px;
  
  @media (max-width: 768px) {
    top: ${props => props.mobileTop || '50px'};
    height: ${props => props.mobileHeight || 'calc(100% - 50px)'};
  }
`;

const GameCanvas = styled.canvas`
  width: 100%;
  height: 100%;
  display: block;
  /* 부드러운 렌더링을 위한 CSS 최적화 */
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
`;

const RhythmCanvas = React.forwardRef(({ canvasRef, canvasWidth, canvasHeight, showResult }, ref) => {
  return (
    <CanvasContainer>
      <GameCanvas
        ref={canvasRef}
        width={canvasWidth}
        height={canvasHeight}
      />
    </CanvasContainer>
  );
});

export default RhythmCanvas;
